import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { workItemUrl, type WorkItem } from "@yagni/shared";
import { PHASE_LABELS, PHASE_ICONS } from "../lib/workItemConstants.js";
import { Badge } from "../ui/index.js";

interface WorkItemMentionProps {
  ticket: WorkItem | null;
  identifierText: string;
  loading?: boolean;
}

export function WorkItemMention({ ticket, identifierText, loading }: WorkItemMentionProps) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Badge
        size="xs"
        className="gap-1 px-1.5 py-0.5 rounded border border-[var(--print-border)] bg-[var(--print-bg)] text-[var(--text-secondary)] text-[11px]"
      >
        <Loader2 size={10} className="animate-spin" />
        {identifierText}
      </Badge>
    );
  }

  if (!ticket) {
    return (
      <Badge
        size="xs"
        className="gap-1 px-1.5 py-0.5 rounded border border-[var(--print-border)] bg-[var(--print-bg)] text-[var(--text-tertiary)] text-[11px]"
      >
        {identifierText}
      </Badge>
    );
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // Open the ticket in its Team's queue (the old Work address redirects there).
    navigate(workItemUrl(ticket.id, ticket.deskId));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] cursor-pointer transition-colors hover:bg-[var(--print-bg-solid)]"
      style={{
        borderColor: "var(--print-border)",
        background: "var(--print-bg)",
        color: "var(--text-primary)",
        verticalAlign: "middle",
      }}
    >
      <span className="font-mono font-medium" style={{ color: "var(--accent)" }}>
        {ticket.identifier}
      </span>
      <span className="truncate max-w-[180px]">{ticket.title}</span>
      <span className="flex items-center gap-0.5" style={{ color: "var(--text-tertiary)" }}>
        {PHASE_ICONS[ticket.phase]}
        <span className="text-[9px]">{PHASE_LABELS[ticket.phase]}</span>
      </span>
    </button>
  );
}
